<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 550px" class="yl-flex flex_between">
				<Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
				<Button style="margin-left: 20px;" type="primary" @click="addAccountButton">添加落地页</Button>
				<Button style="margin-left: 20px;" type="primary" @click="addFormButton">表单样式管理</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">创建时间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<!--div class="multiple">
			<div class="child-div">操作人</div>
			<Select v-model="uid" style="width: 200px;">
				<Option v-for="item in operaterList" :value="item.id" :key="item.id">
					{{item.username }}-[{{item.id}}]
				</Option>
			</Select>
		</div-->
		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ row, index }" slot="name">
					<span>{{row.type}}-{{row.id}}版</span>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
						@click="editAdvPage">编辑</Button>
					<Button type="error" size="small" :data-id="row.id" @click="delAdvPage">删除</Button>
				</template>
				<template slot-scope="{row, index}" slot="status">
					<i-switch v-model="datas[index].status" @on-change="saveOpen($event, index)">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
			</Table>
			<div>
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
			</div>
		</div>
		
		<!--Modal v-model="CreateCostModal" width="1000" title="余额">
			<CreateCost></CreateCost>
		</Modal-->
		<!-- 添加落地页 -->
		<Modal v-model="modal" width="800" title="编辑落地页">
			<Form :label-width="120">
				<FormItem label="落地页链接" v-if="pageForm.url != '' && pageForm.url != undefined">
					<Input placeholder="落地页链接" disabled v-model="linkUrl"></Input>
					<el-select v-model="linkSrcId" filterable style="width:60%;" :label-in-value="true" @change="srcIdChange" placeholder="请选择媒体代码(没有媒体需要先在媒体代码管理添加)">
						<el-option v-for="item in srcIdList"  :label="item.src_name"  :value="item.id" :key="item.id">
		
						</el-option>
					</el-select>
					<Button @click="addSrc" type="primary" style="margin-left: 10px;">添加媒体代码</Button>
					<!--Row>
						<Col span="6"><Input placeholder="媒体代码" v-model="linkSrc"></Input></Col>
						<Col span="6"><Input placeholder="媒体cid" v-model="pageForm.cid"></Input></Col>
						<Col span="12">（两个输入框为复制链接专用）</Col>
					</Row-->
					<div>
						<span style="color: #277dd3; margin-right: 10px;cursor: pointer;" class="copy_area"
							:data-clipboard-text="linkUrl" @click="copyH5">复制登记页链接</span>
					</div>
					
				</FormItem>
				<FormItem label="落地页title">
					<Input placeholder="落地页title" v-model="pageForm.title"></Input>
				</FormItem>
				<FormItem label="备注">
					<Input placeholder="备注" v-model="pageForm.page_name"></Input>
				</FormItem>
				<FormItem label="账户类型">
					<Select @on-change="loadData" v-model="pageForm.cid_type" placeholder="请选择账户类型">
						<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">
							{{ item.type}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="表单样式">
					<Select v-model="pageForm.form_type" placeholder="请选择表单样式">
						<Option v-for="item in formTypeList" :value="item.id" :key="item.id">
							{{ item.form_name}}--{{ item.id}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="图片合集">
					<Row>
						<Col span="6">
						主图：<MyUpload :onlyRead="false" ref="home_picture"></MyUpload>
						</Col>
						<Col span="6">
						底部1：<MyUpload :onlyRead="false" ref="one_picture"></MyUpload>
						</Col>
						<Col span="6">
						底部2：<MyUpload :onlyRead="false" ref="two_picture"></MyUpload>
						</Col>
						<Col span="6">
						底部3：<MyUpload :onlyRead="false" ref="three_picture"></MyUpload>
						</Col>
					</Row>
					<Row>
						<Col span="6">
						底部4：<MyUpload :onlyRead="false" ref="four_picture"></MyUpload>
						</Col>
						<Col span="6">
						底部5：<MyUpload :onlyRead="false" ref="five_picture"></MyUpload>
						</Col>
					</Row>
				</FormItem>
				<FormItem label="按钮颜色">
					<Input placeholder="按钮颜色" v-model="pageForm.button_color"></Input>
				</FormItem>
				<FormItem label="底部文字">
					<Input placeholder="底部文字" v-model="pageForm.footer" :rows="7" type="textarea"></Input>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="pageForm.status">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</FormItem>
				<FormItem label="备注">
					<Input placeholder="备注" v-model="pageForm.remark"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addAdvPage">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
		<!-- 表单样式 -->
		<Modal v-model="form_modal" width="800" title="添加表单格式">
			<FormType></FormType>
		</Modal>
		<Modal v-model="addSrcModal" width="600" title="添加媒体代码">
			<SrcManage :addSrcModalValue = 'addSrcModalValue'></SrcManage>
		</Modal>
	</div>
</template>
<script>
	import MyUpload from '../tool/AdvUpload.vue'
	import SrcManage from './SrcManage.vue'
	import FormType from './components/FormType.vue'
	import Clipboard from 'clipboard';
	import {
		mapGetters
	} from "vuex";
	import {
		getAllMediumCode,
		getAccountStatic,
		getAllAccountList,
		getAdvPageList,
		getAdvPge,
		getAllOperater,
		getToutiaoSrc,
		addAdvPage,
		getCidTypeList,
		saveAccountStatusOpen,
		delAdvPage,
		getFormTypeList
	} from "../../api/advManage";
	import CreateCost from "./components/CreateCost.vue"; //排行榜

	export default {
		name: "AccountStatic",
		props: ['clickTabValue'],
		components: {
			MyUpload,
			CreateCost,
			FormType,
			SrcManage
		},
		data() {
			return {
				modal: false,
				form_modal: false,
				addSrcModal:false,
				addSrcModalValue:'',
				name: '',
				timePeriod: '0',
				timePeriodDate: [],
				datas: [],
				operaterList: [],
				srcList: [],
				cidTypeList: [],
				srcIdList:[],
				formTypeList: [],
				uid: [],
				linkUrl: '',
				linkSrc:'',
				linkCid:'',
				linkSrcId:null,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				pageForm: {
					url: '',
				},
				CreateCostModal: false,
				columns: [{
						"title": "序号",
						type: 'index',
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "落地页title",
						"key": "title",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "落地页名称",
						"slot": "name",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "备注",
						"key": "page_name",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "账户类型",
						"key": "type",
						"align": "center",
					},
					{
						"title": "状态",
						"slot": "status",
						"align": "center",
					},
					{
						title: 'Action',
						slot: 'action',
						width: 250,
						align: 'center'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token','addSrcIdStatus','userInfo']),
			addSrcIdStatus() {
			  return this.$store.state.app.addSrcIdStatus;
			},
		},
		mounted: function() {
			console.log(this.addSrcIdStatus)
			this.loadData();
			this.getList();
		},
		watch: {
			addSrcIdStatus() {
				this.loadData();
			},
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.page = 1;
				this.pageSize = 10;
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.uid = [];
				this.search();
			},
			createCost() {
				this.CreateCostModal = true;
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllOperater(that, data);
				that.operaterList = res.data.list;
				res = await getToutiaoSrc(that, data);
				that.srcList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				that.srcIdList = res.data.src_id_list;
				res = await getFormTypeList(that, data);
				that.formTypeList = res.data.list;
			},
			saveOpen(e, index) {
				console.log(e)
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveAccountStatusOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getAdvPageList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			srcIdChange(){
				let that = this
				that.linkUrl = that.pageForm.url+'&cid='+that.srcIdList[that.linkSrcId].cid+'&src='+that.srcIdList[that.linkSrcId].src_name
			},
			addSrc(){
				this.addSrcModalValue = Date.parse(new Date())
				this.addSrcModal = true;
			},
			copyH5() {
				let that = this;
				if (that.linkSrcId == "" || that.linkSrcId == null) {
					that.$Message.error('媒体代码不能为空');
					return;
				}
				if (that.pageForm.cid == "" || that.pageForm.cid == null) {
					that.$Message.error('媒体cid不能为空');
					return;
				}
				var clipboard = new Clipboard('.copy_area')
				clipboard.on('success', e => {
					that.$Message.success("复制成功");
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					that.$Message.error('该浏览器不支持自动复制')
					clipboard.destroy()
				})
			},
			// 编辑落地页
			async editAdvPage(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getAdvPge(that, data);
				that.linkSrcId = ""
				console.log(res)
				if (res.code == 1) {
					if (res.data.item.home_picture != null && res.data.item.home_picture !== undefined && res.data.item
						.home_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.home_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['home_picture'].uploadList = jsonStr;
					}
					if (res.data.item.one_picture != null && res.data.item.one_picture !== undefined && res.data.item
						.one_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.one_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['one_picture'].uploadList = jsonStr;
					}
					if (res.data.item.two_picture != null && res.data.item.two_picture !== undefined && res.data.item
						.two_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.two_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['two_picture'].uploadList = jsonStr;
					}
					if (res.data.item.home_picture != null && res.data.item.home_picture !== undefined && res.data.item
						.home_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.home_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['home_picture'].uploadList = jsonStr;
					}
					if (res.data.item.three_picture != null && res.data.item.three_picture !== undefined && res.data
						.item.three_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.three_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['three_picture'].uploadList = jsonStr;
					}
					if (res.data.item.four_picture != null && res.data.item.four_picture !== undefined && res.data.item
						.four_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.four_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['four_picture'].uploadList = jsonStr;
					}
					if (res.data.item.five_picture != null && res.data.item.five_picture !== undefined && res.data.item
						.five_picture !== "") {
						var jsonStr = JSON.parse(res.data.item.five_picture); //将视频和图片的json转为数据
						//console.log(jsonStr[0].response.data.url)
						that.$refs['five_picture'].uploadList = jsonStr;
					}
					that.pageForm = res.data.item;
					that.linkUrl = that.pageForm.url;
					that.modal = true;
				}
			},
			// 删除账户
			delAdvPage(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delAdvPage(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			addFormButton() {
				this.form_modal = true;
			},
			addAccountButton() {
				this.pageForm = {};
				this.$refs['home_picture'].uploadList = [];
				this.$refs['one_picture'].uploadList = [];
				this.$refs['two_picture'].uploadList = [];
				this.$refs['three_picture'].uploadList = [];
				this.modal = true;
			},
			async addAdvPage() {
				let that = this;
				let data = {
					token: that.token,
					pageForm: that.pageForm,
				};
				data.home_picture = that.$refs['home_picture'].uploadList;
				data.one_picture = that.$refs['one_picture'].uploadList;
				data.two_picture = that.$refs['two_picture'].uploadList;
				data.three_picture = that.$refs['three_picture'].uploadList;
				let res = await addAdvPage(that, data);
				if (res.code == 1) {
					this.modal = false;
					this.getList();
					that.$Message.success('保存成功');
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
